import { useContext, useEffect, useEffectEvent, useState } from 'react'
import { useAuth } from 'react-oidc-context'
import { Alert, CircularProgress, Grid } from '@mui/material'
import { useSnackbar } from 'notistack'

import { AppContext, useHost } from '../../../../providers/app-provider'
import Api from '../../../../utils/api'
import useSharedStyles from '../../../../utils/shared.styles'
import AccountsContext from '../../context'

import Details from './details'
import Sidebar from './sidebar'
import Subscription from './subscription'

const TabPanelAbout = () => {
  const sharedClasses = useSharedStyles
  const { enqueueSnackbar } = useSnackbar()

  const auth = useAuth()
  const host = useHost()
  const { folder, folderAttributes } = useContext(AccountsContext)
  const { pageRefreshCounter } = useContext(AppContext)
  const [loading, setLoading] = useState<boolean>(true)
  const [aboutData, setAboutData] = useState<IFolderAbout>()

  const fetchData = async () => {
    if (!host || !auth.user?.access_token) return
    if (folder && folderAttributes) {
      setLoading(true)
      const res = await Api.get(`${host}/api/v2/central/folders/${folder?.id}/about`)
      if (res.ok) {
        // TODO: Clean this up once about endpoint has the missing properties
        setAboutData({
          ...res.body,
          installOption: folderAttributes.installOption,
          defaultShippingAddress: {
            ...res.body.defaultShippingAddress,
            company: folderAttributes.defaultShippingAddress.company,
            firstName: folderAttributes.defaultShippingAddress.firstName,
            lastName: folderAttributes.defaultShippingAddress.lastName,
            phone: folderAttributes.defaultShippingAddress.phone,
          },
        })
      } else {
        enqueueSnackbar('Could not get folder information', { variant: 'error' })
      }
      setLoading(false)
    }
  }

  const fetchInitialData = useEffectEvent(fetchData)
  useEffect(() => {
    fetchInitialData()
  }, [folder, folderAttributes, host, pageRefreshCounter])

  if (!loading && aboutData)
    return (
      <Grid
        container={true}
        sx={{
          gap: 2,
        }}
      >
        <Sidebar aboutData={aboutData} refetch={fetchData} />
        <Grid
          container={true}
          size="grow"
          sx={{
            marginBottom: -3,
          }}
        >
          <Details aboutData={aboutData} refetch={fetchData} />
          <Subscription aboutData={aboutData} />
        </Grid>
      </Grid>
    )
  if (!loading && !aboutData) return <Alert severity="error">Could not get folder information</Alert>
  return (
    <Grid container={true} sx={[sharedClasses.centerContent, { marginTop: 12 }]}>
      <CircularProgress />
    </Grid>
  )
}

export default TabPanelAbout
